module.exports = __webpack_public_path__ + "static/media/5_Locate-Wire-Terminal.f82c08ce.svg";